import { mount } from "./app";
import "./styles.css";

mount();

if ("serviceWorker" in navigator && !location.search.includes("nosw")) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// ?debug 时把识别模块挂到 window 上，便于排查
if (location.search.includes("debug")) {
  void import("./lib/vision").then((v) => {
    (window as unknown as { __jq: unknown }).__jq = v;
  });
}
